export const INVENTORY_TRACKPAGE_V2 = "Inventory Trackpage V2";
export const INVENTORY_TRACKPAGE_V2_STEPS = {
  ENTRY: "Entry",
  LOADED: "Loaded",
  SIDE_FILTER_APPLIED: "Side Filter Applied",
  DEMO_RESET_ENTRY: "Demo Reset Entry",
  DEMO_RESET_SUCCESS: "Demo Reset Success",
  DEMO_RESET_FAILURE: "Demo Reset Failure"
};
